function setSearchCriteria({ input, state }) {
  let oldCriteria = state.get('users.searchOptions.criteria')
  if (oldCriteria !== input.criteria) {
    state.set('users.searchOptions.criteria', input.criteria)
  }
}

export default setSearchCriteria



// WEBPACK FOOTER //
// ./src/modules/user/actions/setSearchCriteria.js